export default "__VITE_ASSET__Cpk1BwHA__"